import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class CertifyingExamApplicationjs {
    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    init() {
        let otherSchool = document.querySelector("#otherSchool");
        document.querySelector("#SchoolName").onchange = function (e) {
            if (e.target.value == "Other" || e.target.value == "Autre") {
                otherSchool.hidden = false;
                otherSchool.required = true;
            }
            else {
                otherSchool.hidden = true;
                otherSchool.required = false;
            }
        };
    }

    async applyCertify(e, loadingLabelId, successLabelId, failedValidateId, sectionId) {
        e.preventDefault();
        var that = this;
        let button = this.utilsjs.disableButton(e);

        that.utilsjs.showById(loadingLabelId);
        that.utilsjs.hideById(failedValidateId);

        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'PostCertifyExamApplication', 'Member') === '201') {
            that.utilsjs.hideById(loadingLabelId);
            that.utilsjs.hideById(failedValidateId);
            that.utilsjs.showById(successLabelId);
            that.utilsjs.hideById(sectionId);

        } else {
            that.utilsjs.hideById(loadingLabelId);
            that.utilsjs.hideById(successLabelId);
            that.utilsjs.showById(failedValidateId);
            button.disabled = false;
        }
    }


}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/certifyingExamApplication.js